import { useState, useEffect } from 'react'
import { RECENTS_KEY_NAME } from 'src/pages/utils'

export const useRecents = (userId?: string) => {
  const [recents, setRecents] = useState<Record<string, any[]>>({})

  useEffect(() => {
    try {
      const jsonFromStorage = localStorage.getItem(RECENTS_KEY_NAME)
      if (jsonFromStorage) {
        const object = JSON.parse(jsonFromStorage)
        if (object?.uid === userId) {
          setRecents(object)
        } else {
          localStorage.removeItem(RECENTS_KEY_NAME)
        }
      }
    } catch (e) {
      // Silent fail
    }
  }, [userId])

  return recents
}
